import { render, staticRenderFns } from "./PageContents.vue?vue&type=template&id=4a9b80e8&scoped=true&"
import script from "./PageContents.vue?vue&type=script&lang=js&"
export * from "./PageContents.vue?vue&type=script&lang=js&"
import style0 from "./PageContents.vue?vue&type=style&index=0&id=4a9b80e8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b80e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCheckbox,VCol,VMenu,VRow})
